import { Injectable, Injector } from '@angular/core';
 
import { Chat } from '../../bayadic-shared-models/chat/Chat';
import {Member} from '../../bayadic-shared-models/classes/system/member/Member';
import { SocketManagerProvider } from '../socket-manager/socket-manager';
import {MembersDatabaseManagerProvider} from './database/members-database-manager-provider';
import { ItemsManagerProvider } from '../items-manager/items-manager';
import { UserManagerProvider } from '../user-manager/user-manager';
import { UserObject } from '../../bayadic-shared-models/classes/user/User';
// import { ChatsManagerProvider } from 'src/app/modules/core/Providers/chats-manager';
/*
  Generated class for the MembersManagerProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class MembersManagerProvider {
  public members;
  public actionSyncMembers : string = "syncMembers";
  public actionJoinChat : string = "joinChat";
  public itemsManager : ItemsManagerProvider;
  constructor(
    // private chatsManager: ChatsManagerProvider,
    public socketsMgr : SocketManagerProvider,
    public membersDatabaseMgr : MembersDatabaseManagerProvider,
    public userManager : UserManagerProvider,
    public injector : Injector
    ) {
    this.members = [];
    this.itemsManager = this.injector.get(ItemsManagerProvider);
    this.init();
  }
  init(){
  
  }
  getMembers(chat : Chat){
    this.membersDatabaseMgr.getMembers(chat).then((members)=>{
      chat.members = members;
    }).then(()=>{
        this.sync(chat);
    })
  }
  getMeAsMember(chat : Chat){
    return new Promise((resolve ,rejcet)=>{
      let user = this.itemsManager.userManager.user;
      this.membersDatabaseMgr.getMeAsMember(chat, user).then(
        (member)=>{
        if(member)
          chat.members.push(member);
        resolve(chat);
      })
    })
  }
  getAdmins(chat : Chat){
    return this.membersDatabaseMgr.getAdmins(chat);
  }
  
  addMember(member : Member, chat : Chat){
    this.membersDatabaseMgr.add(member,chat);
  }
  removeMember(member : Member, chat : Chat){
    this.membersDatabaseMgr.remove(member,chat);
  }
  join(chat: Chat){
    this.socketsMgr.asyncQuery(this.actionJoinChat,{chat: chat.getSimpleModel()}).then(
      (response)=>{
          let member = new Member(this.userManager.user as unknown as UserObject);
          this.itemsManager.items.push(chat.item);
          this.itemsManager.backUpitems.push(chat.item);
          chat.members.push(member);
          let itemIndex = this.itemsManager.publicItems.indexOf(chat.item);
          this.itemsManager.publicItems.splice(itemIndex, 1);
          
          this.addMember(member,chat);
          this.itemsManager.add(chat.item);
    });
  }
  sync(chat: Chat){
    
    this.socketsMgr.asyncQuery<MemberSyncResult, any>(this.actionSyncMembers,{chatID : chat.chatID, localMembersIDs : chat.getMemberIDs()})
    .then(result =>{
          let newMembersData  = result.created;
          
          let deletedMembersData  = result.deleted;
          for(let memberData of newMembersData){
            let member = new Member({role:memberData} as UserObject);          
            chat.members.push(member);
            this.membersDatabaseMgr.add(member,chat);
          }
          //TODO : for let for deleted members
    })
  }

}
interface MemberSyncResult {
  created: Array<string>;
  deleted: Array<string>;
}